import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper } from '@mui/material';
import ManageAppContentAssets from '../app-content/manage-app-content-assets.component';

const AppAssetsTheme = ({ channelDetail, handleRefreshData, viewMode }) => (
  <Box component={Paper} width="100%">
    <ManageAppContentAssets
      channelId={channelDetail.id}
      channelCode={channelDetail.code}
      handleRefreshData={handleRefreshData}
      viewMode={viewMode}
    />
  </Box>
);

AppAssetsTheme.propTypes = {
  channelDetail: PropTypes.object.isRequired,
  handleRefreshData: PropTypes.func,
  viewMode: PropTypes.bool,
};
AppAssetsTheme.defaultProps = {
  handleRefreshData: () => {},
  viewMode: false,
};

export default AppAssetsTheme;
